import { render, staticRenderFns } from "./topBlock.vue?vue&type=template&id=5d894e59&"
import script from "./topBlock.vue?vue&type=script&lang=js&"
export * from "./topBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports